import React from 'react'

import { SvgProps } from '../../model/types'

const ArrowLeftIcon: React.FC<SvgProps> = props => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="currentColor"
			{...props}
		>
			<path d="M3.03009 9.41084C2.70465 9.73626 2.70465 10.2639 3.03009 10.5893L7.74414 15.3034C8.06957 15.6288 8.59723 15.6288 8.92264 15.3034C9.24806 14.978 9.24806 14.4503 8.92264 14.1249L5.63119 10.8334H16.6667C17.127 10.8334 17.5001 10.4603 17.5001 10.0001C17.5001 9.53984 17.127 9.16676 16.6667 9.16676H5.63119L8.92264 5.87532C9.24806 5.54988 9.24806 5.02224 8.92264 4.69681C8.59723 4.37137 8.06957 4.37137 7.74414 4.69681L3.03009 9.41084Z" />
		</svg>
	)
}

export default ArrowLeftIcon
